module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"name":"Имя","nameSaved":"Имя сохранено","change":"Изменить","errors":{"name":{"required":"Имя обязательно нужно","string":"В имени нельзя писать загадочные символы","min":"Имя должно быть хотя бы из трех букв"}}}}')
  delete Component.options._Ctor
}
